import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center'
    }
}));

const Consent = () => {
    const classes = useStyles();

    const getConsent = function () {
        return document.cookie.split(';').some((item) => item.includes('.AspNet.Consent=yes'));
    };

    const isReactSnap = typeof window !== 'undefined' && navigator.userAgent === 'ReactSnap';
    const [consent, setConsent] = useState(getConsent());
    const [open, setOpen] = useState(!consent && !isReactSnap);

    const applyConsent = function () {
        setConsent(true);
        var date = new Date();
        var newDate = new Date(date.setMonth(date.getMonth() + 1));
        document.cookie = ".AspNet.Consent=yes; expires=" + (newDate.toUTCString())+"; path=/; secure; samesite=strict";
    };
    const handleConsent = () => {
        applyConsent(true);
        setOpen(false);
    }
    const handleClose = () => {
        setOpen(false);
        applyConsent(true);
    }

    return (
        <Snackbar open={open} onClose={handleClose} className={classes.root}>
            <Alert onClose={handleClose} severity="info">
                We use cookies to improve your experience on our site. To find out more, read our <a href="https://www.uow.edu.au/privacy/">privacy &amp; cookie usage</a> information<br />
                <Button onClick={handleConsent} color="default" variant="contained">OK, THANKS</Button>
        </Alert>
        </Snackbar>
    );
};

export default Consent;
